import IconTitleSectionBody from './icon-title-section-body';
import IconTitleSectionHeader from './icon-title-section-header';
import { ICONS } from './icons';
import StrokeContainer from './stroke-container';

export default class IconTitleSection extends StrokeContainer {
	public set icon(value: keyof typeof ICONS | null) {
		this.header.icon = value;
	}

	public get icon(): keyof typeof ICONS | null {
		return this.header.icon;
	}

	public set text(value: string) {
		this.header.text = value;
	}

	public get text(): string {
		return this.header.text;
	}
	#header!: IconTitleSectionHeader;
	#body!: IconTitleSectionBody;
	public constructor() {
		super();
		this.gapVertical = 12;
		// what the body holds is clipped to the section rather than spilling over its edge: a list longer
		// than the section scrolls inside it, and a drawing wider than it is cut off at it
		this.clipContent = true;
		// and scrolls without a bar: the sections sit side by side with lines between them, and a bar
		// along the edge of one would read as a line too
		this.hideScrollbars = true;
	}

	public get header(): IconTitleSectionHeader {
		if (!this.#header) {
			this.#header = new IconTitleSectionHeader();
		}
		return this.#header;
	}

	public get body(): IconTitleSectionBody {
		if (!this.#body) {
			this.#body = new IconTitleSectionBody();
		}
		return this.#body;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.header, this.body]);
	}
}
customElements.define('ac-icon-title-section', IconTitleSection);
